import {useEffect} from 'react';

let holders = 0;
let injected: HTMLMetaElement | null = null;

/**
 * Refcounted because the pending and ready share views overlap while React swaps them,
 * and the tag in index.html is never ours to remove.
 */
export function useNoIndex(enabled = true): void {
  useEffect(() => {
    if (!enabled) return;

    holders += 1;

    if (!document.querySelector('meta[name="robots"]')) {
      injected = document.createElement('meta');
      injected.name = 'robots';
      injected.content = 'noindex, nofollow';
      document.head.appendChild(injected);
    }

    return () => {
      holders -= 1;

      if (holders === 0) {
        injected?.remove();
        injected = null;
      }
    };
  }, [enabled]);
}
